<div class="confirm-modal" [ngClass]="'tone-' + tone">
  <div class="modal-accent"></div>

  <div mat-dialog-content class="modal-content">
    <div class="modal-badge">
      <mat-icon>{{ icon }}</mat-icon>
    </div>

    @if (eyebrow) {
      <span class="modal-eyebrow">{{ eyebrow }}</span>
    }

    <h1>{{ title }}</h1>
    <p [innerHTML]="message"></p>
  </div>

  <div mat-dialog-actions class="modal-actions">
    <button mat-stroked-button class="secondary-btn" (click)="close()">
      {{ cancelText || "Cancelar" }}
    </button>

    <button mat-flat-button class="primary-btn" (click)="confirm()">
      {{ confirmText || "Sí" }}
    </button>
  </div>
</div>
